export default "__VITE_ASSET__5Rens3dJ__"